(function () {
  const offerUrl = '/pages/offer';
  const offerTextPattern = /make an offer|inquire for this artwork|contact gallery/i;
  const offerSelector = [
    '.make-an-offer-btn',
    '.contact-gallery-btn',
    '.seller-contact-btn',
    '[data-offer-link]',
    '[onclick*="openOfferModal"]',
    '[id="contactGalleryTrigger"]'
  ].join(',');

  function isOfferTrigger(element) {
    if (!element || !(element instanceof HTMLElement)) return false;
    if (element.matches(offerSelector)) return true;

    const text = (element.textContent || '').trim();
    return offerTextPattern.test(text);
  }

  function readContextNode(node) {
    if (!node || !(node instanceof Element)) return null;

    if (
      node.dataset?.offerArtworkTitle ||
      node.dataset?.offerArtistName ||
      node.dataset?.offerProductHandle ||
      node.dataset?.offerProductUrl
    ) {
      return {
        artwork: node.dataset.offerArtworkTitle || '',
        artist: node.dataset.offerArtistName || '',
        handle: node.dataset.offerProductHandle || '',
        price: node.dataset.offerPrice || '',
        currency: node.dataset.offerCurrency || '',
        product_url: node.dataset.offerProductUrl || ''
      };
    }

    const container = node.closest('.art-gallery-actions, .gallery-contact-card, .product-details, .product-information');
    if (!container) return null;

    const contextNode = container.querySelector('[data-offer-product-context]');
    if (!contextNode) return null;

    try {
      const context = JSON.parse(contextNode.textContent || '{}');
      if (context && context.artwork) return context;
    } catch (error) {
      return null;
    }

    return null;
  }

  function readStoredContext() {
    try {
      return JSON.parse(window.sessionStorage.getItem('monitillo_offer_context') || '{}');
    } catch (error) {
      try {
        return JSON.parse(window.localStorage.getItem('monitillo_offer_context') || '{}');
      } catch (localError) {
        return {};
      }
    }
  }

  function writeStoredContext(context) {
    try {
      window.sessionStorage.setItem('monitillo_offer_context', JSON.stringify(context));
    } catch (error) {}

    try {
      window.localStorage.setItem('monitillo_offer_context', JSON.stringify(context));
    } catch (error) {}
  }

  function getProductHandleFromUrl(value) {
    if (!value) return '';

    try {
      const url = new URL(value, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      const match = value.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    }
  }

  function normalizeContext(context) {
    if (!context) return {};

    const normalized = { ...context };
    const handle = normalized.handle || normalized.product_handle || '';
    const productUrlHandle = getProductHandleFromUrl(normalized.product_url);

    if (handle && productUrlHandle && handle !== productUrlHandle) {
      normalized.product_url = `${window.location.origin}/products/${handle}`;
    }

    return normalized;
  }

  function collectContext(trigger) {
    const globalContext = window.monitilloOfferProductContext;
    const storedContext = readStoredContext();
    const triggerContext = readContextNode(trigger);

    return normalizeContext(triggerContext || globalContext || storedContext || {});
  }

  function normalizeOfferTriggers(root) {
    const scope = root || document;
    const candidates = scope.querySelectorAll('a, button, [role="button"]');

    candidates.forEach((candidate) => {
      if (!isOfferTrigger(candidate)) return;

      candidate.removeAttribute('onclick');
      candidate.setAttribute('data-offer-link', 'true');

      const href = candidate.getAttribute('href') || '';
      if (candidate.tagName === 'A' && !href.includes('/pages/offer')) {
        candidate.setAttribute('href', offerUrl);
      }
    });
  }

  function getOfferUrl(trigger) {
    const context = collectContext(trigger);

    if (context && context.artwork) {
      const params = new URLSearchParams();
      params.set('artwork', context.artwork || '');
      params.set('artist', context.artist || '');
      params.set('product_handle', context.handle || '');
      params.set('price', context.price || '');
      params.set('currency', context.currency || '');
      params.set('product_url', context.product_url || '');

      try {
        writeStoredContext(context);
      } catch (error) {
        // Ignore storage errors; the URL still carries the context.
      }

      return `${offerUrl}?${params.toString()}`;
    }

    const params = new URLSearchParams();
    const artwork = trigger?.dataset?.offerArtworkTitle || context.artwork;
    const artist = trigger?.dataset?.offerArtistName || context.artist;
    const productHandle = trigger?.dataset?.offerProductHandle || context.handle;
    const price = trigger?.dataset?.offerPrice || context.price;
    const currency = trigger?.dataset?.offerCurrency || context.currency;
    const productUrl = trigger?.dataset?.offerProductUrl || context.product_url;

    if (artwork) params.set('artwork', artwork);
    if (artist) params.set('artist', artist);
    if (productHandle) params.set('product_handle', productHandle);
    if (price) params.set('price', price);
    if (currency) params.set('currency', currency);
    if (productUrl) params.set('product_url', productUrl);

    if (params.toString()) {
      try {
        writeStoredContext({
          artwork: artwork || '',
          artist: artist || '',
          handle: productHandle || '',
          price: price || '',
          currency: currency || '',
          product_url: productUrl || ''
        });
      } catch (error) {
        // Ignore storage errors; the URL still carries the context.
      }

      return `${offerUrl}?${params.toString()}`;
    }

    if (trigger && trigger.tagName === 'A') {
      const href = trigger.getAttribute('href');
      if (href && href.includes('/pages/offer')) {
        try {
          const url = new URL(href, window.location.origin);
          if (url.search) {
            writeStoredContext({
              artwork: url.searchParams.get('artwork') || url.searchParams.get('title') || '',
              artist: url.searchParams.get('artist') || '',
              handle: url.searchParams.get('product_handle') || '',
              price: url.searchParams.get('price') || '',
              currency: url.searchParams.get('currency') || '',
              product_url: url.searchParams.get('product_url') || ''
            });
          }
        } catch (error) {
          // Keep normal navigation if URL parsing fails.
        }

        return href;
      }
    }

    return offerUrl;
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('a, button, [role="button"]');

    if (!isOfferTrigger(trigger)) return;

    event.preventDefault();
    event.stopPropagation();

    const context = collectContext(trigger);
    const destination = getOfferUrl(trigger);

    if (typeof fbq === 'function') {
      try {
        const payload = {
          content_name: context.artwork || '',
          content_category: 'Artwork',
          content_ids: [context.handle || ''],
          value: parseFloat(context.price) || 0,
          currency: context.currency || 'EUR'
        };
        fbq('trackCustom', 'InitiateOffer', payload);
        fbq('track', 'Contact', payload);
      } catch (e) {
        console.error('Meta Pixel tracking error:', e);
      }
    }

    setTimeout(function () {
      window.location.assign(destination);
    }, 100);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    normalizeOfferTriggers(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeOfferTriggers(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  });
})();
